import { useTranslation } from 'react-i18next';

import { formatPrice } from '@/app/utils/formatting';
import { ProjectDonationAmount } from '@/app/api';
import { getAmountInRespectiveCurrency } from '@/app/utils/numbers';

export const useDonationAmountOptions = (donationAmounts: ProjectDonationAmount[] | null) => {
  const { t } = useTranslation();

  const otherValueOption = { value: 0, label: t('components.DonationForm.anotherAmount') };

  if (!donationAmounts || donationAmounts.length === 0) {
    return [otherValueOption];
  }

  const options = donationAmounts
    .sort((a, b) => b.amountInCents - a.amountInCents)
    .map((amount) => {
      const formattedPrice = formatPrice(getAmountInRespectiveCurrency(amount.amountInCents));
      return {
        label: amount.name ? `${formattedPrice} (${amount.name})` : formattedPrice,
        value: getAmountInRespectiveCurrency(amount.amountInCents),
      };
    });

  return [...options, otherValueOption];
};
